import { SORUMLU_GUNCELLE } from "../constants/requestUrls";

import { postRequest } from "../request";

const sorumluGuncelle = (data) => {
  return postRequest({ url: SORUMLU_GUNCELLE, data });
}

export default sorumluGuncelle;